import { BehaviorSubject } from "rxjs";

export const openDialogConfirmation$ = new BehaviorSubject<boolean>(false);
export const setupDialog$ = new BehaviorSubject<IConfirmationDialog>({
  title: "",
  content: "",
  onClose: () => { },
  onNegation: () => { },
  onConfirmation: () => { },
  yesText: "Sim",
  noText: "Não",
  yesVariant: "contained",
  noVariant: "text",
  fullWidth: false,
  size: "300px",
});

type variant = "text" | "outlined" | "contained"

export interface IConfirmationDialog {
  title: React.ReactNode;
  content: React.ReactNode;
  onConfirmation: Function;
  onNegation?: Function;
  onClose: Function;
  yesText?: string;
  noText?: string;
  yesVariant?: variant;
  noVariant?: variant;
  fullWidth?: boolean;
  size?: string | number | null;
}

type ConfirmationDialogType = {
  open: () => void,
  close: () => void,
  setup: (params: IConfirmationDialog) => void,
}

const ConfirmationDialog = (): ConfirmationDialogType => {
  let setup: IConfirmationDialog = setupDialog$.getValue();
  return {
    setup: (params: IConfirmationDialog) => {
      const { title, content, noText, size, yesText, onClose, onConfirmation, onNegation, yesVariant, noVariant, fullWidth } = params;

      setup.title = title;
      setup.content = "";
      setup.noText = noText;
      setup.size = size;
      setup.yesText = yesText;
      setup.onClose = onClose;
      setup.onClose = onClose;
      setup.onConfirmation = onConfirmation;
      setup.onNegation = onNegation;
      setup.noVariant = noVariant;
      setup.fullWidth = fullWidth;
      setup.yesVariant = yesVariant;

      setupDialog$.next(setup);
      setTimeout(() => {
        setup.content = content;
        setupDialog$.next(setup);
      }, 500)
    },
    close: () => {
      openDialogConfirmation$.next(false);
    },
    open: () => {
      setTimeout(() => {
        openDialogConfirmation$.next(true);
      }, 500)
    },
  }

}

const confirmationDialog = ConfirmationDialog();

export { confirmationDialog };